import script from "./ForceLogoutModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ForceLogoutModal.vue?vue&type=script&setup=true&lang=js"

import "./ForceLogoutModal.vue?vue&type=style&index=0&id=622409b8&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-622409b8"]])

export default __exports__